import { api } from "aldoo-ra/API"

const storeAPI = api("store")
const timezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return undefined
  }
}

/**
 * The whole store's sales report (aldoo-na `store {sales_report}`, admin):
 * the api StoreSales reads unless a project passes its own.
 *   report({ dateRange, page, items_per_page, order_by, search }) → { data, total, views }
 *   series({ pids, aggregate, dateRange, group }) → { unit, buckets, series, views }
 */
export const storeSalesAPI = {
  report: (options) => storeAPI({ sales_report: { timezone: timezone(), ...options } }),
  series: ({ pids, aggregate, dateRange, group = false }) => storeAPI({ sales_report: { timeline: pids?.length ? { pids } : {}, aggregate, dateRange, group, timezone: timezone() } }),
}
